// src/components/Toast.js
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

// Toast simple auto-dismiss. Se renderiza via portal a document.body para
// garantizar que su `position: fixed` no quede atrapado por un ancestro con
// `backdrop-filter` u otra propiedad que cree containing block.
function Toast({ message, type = 'info', duration = 4000, onDismiss }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) return undefined;

    // Disparar animacion de entrada en el siguiente frame.
    const enterRaf = requestAnimationFrame(() => setVisible(true));

    const hideTimeout = window.setTimeout(() => {
      setVisible(false);
    }, Math.max(0, duration - 200));

    const dismissTimeout = window.setTimeout(() => {
      if (typeof onDismiss === 'function') onDismiss();
    }, duration);

    return () => {
      cancelAnimationFrame(enterRaf);
      window.clearTimeout(hideTimeout);
      window.clearTimeout(dismissTimeout);
    };
  }, [message, duration, onDismiss]);

  if (!message) return null;

  return createPortal(
    <div
      className={`toast toast--${type}${visible ? ' toast--visible' : ''}`}
      role={type === 'error' ? 'alert' : 'status'}
      aria-live={type === 'error' ? 'assertive' : 'polite'}
    >
      <span className="toast-message">{message}</span>
    </div>,
    document.body
  );
}

export default Toast;
